"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMaximumDateInfo = exports.validateMaximumDateSync = exports.validateMaximumDate = exports.shouldValidate = void 0;
const error_1 = require("../../../error");
const date_1 = require("../../../utils/date");
const isValidatableDateComponent = (component) => {
    var _a;
    return component && component.type === 'datetime' && ((_a = component.widget) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('maxDate'));
};
const shouldValidate = (context) => {
    var _a;
    const { component, value } = context;
    if (!isValidatableDateComponent(component) || !value) {
        return false;
    }
    if (!(0, date_1.getDateSetting)((_a = component.widget) === null || _a === void 0 ? void 0 : _a.maxDate)) {
        return false;
    }
    return true;
};
exports.shouldValidate = shouldValidate;
const validateMaximumDate = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.validateMaximumDateSync)(context);
});
exports.validateMaximumDate = validateMaximumDate;
const validateMaximumDateSync = (context) => {
    var _a, _b, _c, _d;
    const { component, value } = context;
    if (!(0, exports.shouldValidate)(context)) {
        return null;
    }
    if (typeof value !== 'string') {
        throw new error_1.ProcessorError(`Cannot validate day value ${value} because it is not a string`, context, 'validate:validateMaximumDate');
    }
    const date = (0, date_1.dayjs)(value);
    let maxDate = (0, date_1.getDateSetting)((_a = component.widget) === null || _a === void 0 ? void 0 : _a.maxDate);
    if (maxDate === null) {
        return null;
    }
    maxDate = ((_b = component.widget) === null || _b === void 0 ? void 0 : _b.enableTime)
        ? (0, date_1.dayjs)(maxDate)
        : (0, date_1.dayjs)(maxDate).endOf('day');
    const error = new error_1.FieldError('maxDate', Object.assign(Object.assign({}, context), { maxDate: (0, date_1.getFormattedDateSetting)(maxDate, component, (_d = (_c = context.submission) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.timezone), setting: String(maxDate) }));
    return date.isBefore(maxDate) || date.isSame(maxDate) ? null : error;
};
exports.validateMaximumDateSync = validateMaximumDateSync;
exports.validateMaximumDateInfo = {
    name: 'validateMaximumDate',
    process: exports.validateMaximumDate,
    processSync: exports.validateMaximumDateSync,
    shouldProcess: exports.shouldValidate,
};
